import React from 'react';
import { fade, useTheme } from '@material-ui/core/styles';

export default function StripeInput(props) {
  const {
    component: Component,
    inputRef,
    'aria-invalid': ariaInvalid,
    'aria-describedby': ariaDescribeBy,
    defaultValue,
    required,
    onKeyDown,
    onKeyUp,
    readOnly,
    autoComplete,
    autoFocus,
    type,
    name,
    rows,
    ...other
  } = props;
  const theme = useTheme();
  const [mountNode, setMountNode] = React.useState(null);

  React.useImperativeHandle(
    inputRef,
    () => ({
      focus: () => mountNode.focus(),
    }),
    [mountNode],
  );

  return (
    <Component
      showIcon
      onReady={setMountNode}
      style={{
        base: {
          fontFamily: ['"Roboto"', 'sans-serif'].join(','),
          fontSize: '26px',
          lineHeight: '40px',
          fontWeight: 400,
          //marginBottom: '20px',
          //backgroundColor: 'yellow',
          '&::placeholder': {
            opacity: 1,
            color: '#9e9e9e',
            fontFamily: ['"Roboto"', 'sans-serif'].join(','),
            fontWeight: 400,
          },
        },
        invalid: {
          color: theme.palette.text.primary,
        },
      }}
      {...other}
    />
  );
}
